// extracted by mini-css-extract-plugin
module.exports = {"fromSide":"styles_fromSide__SKnyd","dsModalOut":"styles_dsModalOut__zf2h1","dsModalIn":"styles_dsModalIn__YxDoe"};